<template>
  <div>

    <div class="d-flex justify-space-between mb-5">
      <div>
        <div class="page-title mb-2">
          พิจารณาแผนงาน
        </div>
      </div>
    </div>

    <div>
      <div class="d-flex justify-space-between table-head">
        <div
            v-for="(item, i) in tableHeader"
            :key="i"
            :style="{ 'width': item.width }"
        >
          {{ item.name }}
        </div>
      </div>

      <div class="list-layout">
        <EvaluateListItem
            v-for="(item, i) in formAList"
            :key="i"
            :item="item"
            :index="i"
            :headers="tableHeader"
        ></EvaluateListItem>
      </div>
    </div>

  </div>
</template>

<script>
import TextField from "../../components/input/TextField"
import Button from "../../components/input/Button"
import SelectBox from "../../components/input/SelectBox"
import EvaluateListItem from "../../components/EvaluateListItem"

export default {
  name: "EvaluateList",
  components: {
    TextField,
    SelectBox,
    EvaluateListItem,
    Button
  },
  data () {
    return {
      tableHeader: [
        {
          name: 'ลำดับ',
          width: '10%'
        },
        {
          name: 'ชื่อแผนงาน',
          width: '50%'
        },
        {
          name: 'ภูมิภาค',
          width: '20%'
        },
        {
          name: '',
          width: '20%'
        }
      ],
      formAList: []
    }
  },
  created () {
    this.getFormAList()
  },
  methods: {
    async getFormAList () {
      let res
      res = await this.$apiFire('BForm/getFormBList')
      console.log(res)
      this.formAList = res
    },
  }
}
</script>

<style scoped lang="scss">
.table-head {
  padding: 0 33px 0 36px;
  margin-bottom: 12px;
  gap: 8px;
}

.list-layout {
  display: flex;
  flex-direction: column;
  gap: 12px;
}
</style>